import * as React from 'react';
import {useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

export default function ActivatePlanDialog({ open, onClose, token, onSuccess, insurer, planName, planUID }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!planUID) {
            setError("");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`/admin/api/v1/users/plans/${planUID}/activate`, {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            onSuccess();
            onClose();
        } catch (error) {
            console.error('Error:', error);
            setError(`An error occurred while activating plan:${planUID}. Please try again.`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                PaperProps={{
                    component: 'form',
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleSubmit();
                    },
                }}
            >
                <DialogTitle><b>Aktivierung des Benutzerplans</b></DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Sie sind dabei, den vom Benutzer ausgewählten Plan zu aktivieren.
                        <br/>Möchten Sie wirklich mit der Aktivierung fortfahren? <b>"{insurer}, {planName}"</b>?
                    </DialogContentText>
                    <br/>
                    {error && <p style={{color: 'red'}}>{error}</p>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} disabled={loading}>Stornieren</Button>
                    <Button type="submit" disabled={loading || !planUID}>
                        {loading ? <CircularProgress size={24}/> : 'Aktivieren'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
